import { v4 as uuidv4 } from 'uuid';
import nearMeData from './data/near-me-publishers.json';

function getNearMePublishers() {
    this.nearMePublishers = nearMeData.publishers;
    this.observed.nearMePublishers = uuidv4();
}

export default getNearMePublishers;
